<template>
  <div
    class="iframe-container"
    :class="{ allScreen: isAllScreen }"
    v-loading="loading"
    :style="{ 'min-height': clientHeight }"
  >
    <!-- <div class="header-wrap" v-if="isBigScreen">
      <div class="full-wrap" @click="toggleAllScreenFull(false)" v-if="isAllScreen">
        <i class="el-icon-full-screen"></i>
        <span>{{ $t('dashboard-bi::default-board::no_screen') }}</span>
      </div>

      <div class="full-wrap" @click="toggleAllScreenFull(true)" v-else>
        <i class="el-icon-full-screen"></i>
        <span>{{ $t('dashboard-bi::default-board::screen') }}</span>
      </div>
      <div class="full-wrap" @click="onNewTab" v-if="isBigScreen">
        <i class="el-icon-link"></i>
        <span>{{ $t('dashboard-bi::default-board::新窗口打开') }}</span>
      </div>
    </div> -->
    <iframe id="iframe" :src="url" :title="$route.meta.name" @load="onload" class="iframe-wrap"></iframe>
    <handleIcon v-if="showHandler" @allScreen="toggleAllScreenFull(!isAllScreen)" :isAllScreen="isAllScreen">
      <template slot="menu">
        <!-- <li @click="toggleAllScreenFull(false)" v-if="isAllScreen">
          <div class="icon">
            <i class="iconfont iconquanping1"></i>
          </div>
          <span>{{ $t('dashboard-bi::default-board::screen') }}</span>
        </li>
        <li @click="toggleAllScreenFull(true)" v-else>
          <div class="icon">
            <i class="iconfont iconquanping1"></i>
          </div>
          <span>{{ $t('dashboard-bi::default-board::screen') }}</span>
        </li> -->
        <li @click="onNewTab" v-if="isBigScreen">
          <div class="icon">
            <i class="iconfont iconlianjie"></i>
          </div>
          <span>{{ $t('dashboard-bi::default-board::新窗口打开') }}</span>
        </li>
      </template>
    </handleIcon>
  </div>
</template>

<script>
import qs from 'querystring'
import Cookies from 'js-cookie'
import { toggleAllScreen } from '@/utils/utils.js'
import { _local } from '@/utils/storage'
import { addResizeListener, removeResizeListener } from '@/utils/resize-event'
import handleIcon from '@/components/handle-icon/index.vue'
export default {
  name: 'iframe',
  components: { handleIcon },
  data() {
    return {
      clientHeight: '100%',
      loading: true,
      listenAllScreenKeyUp: null, // 监听全屏案件
      showHandler: false,
    }
  },
  mounted() {
    const self = this

    this.$nextTick(() => {
      document.querySelector('#iframe').onload = function () {
        self.loading = false
      }
      this.clientHeight = this.isAllScreen ? window.innerHeight + 'px' : window.innerHeight - 96 + 'px'
      this.listenAllScreenKeyUp = e => {
        //   /*判断是否全屏*/
        var isFullscreen =
          document.fullScreenElement || // W3C
          document.msFullscreenElement || // IE
          document.mozFullScreenElement || // 火狐
          document.webkitFullscreenElement || // 谷歌
          false
        this.$store.commit('setScreen', isFullscreen ? true : false)
        this.clientHeight = isFullscreen ? window.innerHeight + 'px' : window.innerHeight - 96 + 'px'
        setTimeout(() => {
          try {
            this.$parent.$parent.update()
          } catch (e) {
            console.log(e)
          }
        }, 100)
      }
      addResizeListener(document.body, this.listenAllScreenKeyUp)
    })
  },
  methods: {
    onload() {
      this.showHandler = true
    },
    onNewTab() {
      window.open(this.url)
    },

    toggleAllScreenFull(bool) {
      this.$store.commit('setScreen', bool)
      toggleAllScreen()
    },
  },
  computed: {
    isBigScreen() {
      return this.url.indexOf('bi-screen') >= 0
    },
    url() {
      const merchantId = _local.get('merchantId')
      const checkEdit =
        this.$auth('data-board-customer::eCommercoDaily::BOARD_EDIT') ||
        this.$auth('data-board-customer::eCommercoDaily::RL-BOARD_EDIT')
      this.$auth('data-board-customer::eCommercoDaily::GL-BOARD_EDIT')
      this.$auth('data-board-customer::eCommercoDaily::MW-BOARD_EDIT')
      const checkShare =
        this.$auth('data-board-customer::eCommercoDaily::BOARD_SHARE') ||
        this.$auth('data-board-customer::eCommercoDaily::RL-BOARD_SHARE')
      this.$auth('data-board-customer::eCommercoDaily::GL-BOARD_SHARE')
      this.$auth('data-board-customer::eCommercoDaily::MW-BOARD_SHARE')
      const checkGroupEdit =
        this.$auth('data-board-customer::eCommercoDaily::GROUP_EDIT') ||
        this.$auth('data-board-customer::eCommercoDaily::RL-GROUP_EDIT')
      this.$auth('data-board-customer::eCommercoDaily::GL-GROUP_EDIT')
      this.$auth('data-board-customer::eCommercoDaily::MW-GROUP_EDIT')
      let link = decodeURIComponent(qs.stringify(this.$route.query).split('iframe=').pop())
      let url = `${link}${
        !link.includes('?') ? '?' : '&'
      }BOARD_EDIT=${checkEdit}&BOARD_SHARE=${checkShare}&GROUP_EDIT=${checkGroupEdit}&editAutho=1&merchantId=${merchantId}&token=${Cookies.get(
        'saasToken'
      )}`
      // !link.includes('?')
      //   ? link
      //   : link +
      //       `&BOARD_EDIT=${checkEdit}&BOARD_SHARE=${checkShare}&GROUP_EDIT=${checkGroupEdit}&editAutho=1&merchantId=${merchantId}&token=${Cookies.get(
      //         'saasToken'
      //       )}`

      // console.log(url, '测试')
      // mw 为103， 写死，不配重新配链接 ， 创乐为100
      if (merchantId == 103 && this.$route.name == 'day-board') {
        url = url.replace('boardID=161', 'boardID=175').replace('folderID=1100', 'folderID=1103')
      }
      return url
    },
    isAllScreen() {
      return this.$store.state.isAllScreen
    },
  },
  beforeDestroy() {
    removeResizeListener(this.listenAllScreenKeyUp)
  },
}
</script>

<style lang="scss" scoped>
.full-height {
  height: calc(100vh - 60px) !important;
  padding-top: 48px;
}
.iframe-container {
  position: relative;
  margin: -24px;
  width: calc(100% + 48px) !important;
  height: calc(100vh - 96px);
  .header-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    padding: 0 24px;
    box-sizing: border-box;
    box-shadow: 0 0 10px #f0f0f0;
    .full-wrap {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      cursor: pointer;
      .el-icon-full-screen,
      .el-icon-link {
        margin-right: 5px;
      }
      .el-icon-link {
        margin-left: 12px;
      }
    }
  }
}
.iframe-wrap {
  width: 100%;
  height: 100%;
}
.allScreen {
  position: fixed;
  left: 0px;
  top: 0;
  width: 100% !important;
  height: 100% !important;
  z-index: 2000;
  background-color: #f0f2f5;
  // padding: 40px 0 0 0;
  box-sizing: border-box;
  margin: 0;
  overflow: auto;
}
</style>
